// extracted by mini-css-extract-plugin
module.exports = {"samlLoginForm":"SamlLogin_samlLoginForm__24ZWS","loginButton":"SamlLogin_loginButton__1yCrF","emailInput":"SamlLogin_emailInput__1wFim"};